import React from "react";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../../animation/motionAnimation";

const ResponsivePolicyCard = ({ image, title, des }) => {
  return (
    <div className="my-2 text-center ">
      <div className="overflow-hidden">
        <motion.h2
          {...fadeInAnimation}
          className="text-xl font-semibold uppercase my-4 text-g-black"
        >
          {title}
        </motion.h2>
      </div>
      <div className="flex justify-center my-4">
        <img src={image} className="w-full h-60 object-center rounded-2xl" />
      </div>

      <p className="md:text-lg sm:text-md max-sm:text-md text-mute-grey">
        {des}
      </p>
    </div>
  );
};

export default ResponsivePolicyCard;
